import React from "react";
import {
    AboutUs,
    ContactUs,
    Hero,
    OurPartner,
    OurServices,
    Questions,
    Ratings,
    Statistic,
    TrackYourOrder
} from "../components";


function Home() {
    return (
        <main className="p-0 m-0">
            <Hero />
            <TrackYourOrder />
            <OurServices />
            <AboutUs />
            <Statistic />
            <ContactUs />
            <OurPartner />
            <Ratings />
            <Questions />
        </main>
    );
}

export default Home;
